(function () {
  const clientId = '270118790436-6i21htaodbc33n213h8utkvisd6aashm.apps.googleusercontent.com';
  const scriptSrc = 'https://accounts.google.com/gsi/client';
  let initialized = false;

  const script = document.getElementById('google-one-tap-login');
  const apiUrl = script && script.dataset.apiUrl;
  const enabledMb = script && script.dataset.enabledMb;

  function reportOneTapEvent(eventName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: {
          current_page: window.location.href,
      }
    });
  }

  function isAccountLogoutFlow() {
    // 判断 cookie us_navimow_logout_ts 是否存在且为今天，则返回 true 
    var siteCode = window.site ? window.site.toLowerCase() : 'test_us';
    if(siteCode === 'us') siteCode = 'us2';
    if(siteCode === 'de') siteCode = 'de2';
    if(siteCode === 'fr') siteCode = 'fr2';
    var cookieName = siteCode + '_navimow_logout_ts';
    var cookieMatch = document.cookie.match(new RegExp('(?:^|;\\s*)' + cookieName.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '\\s*=\\s*([^;]*)'));
    if (cookieMatch && cookieMatch[1]) {
      var logoutTs = parseInt(cookieMatch[1], 10);
      if (!isNaN(logoutTs)) {
        var logoutDate = new Date(logoutTs);
        var now = new Date();
        // 比较年月日
        if (
          logoutDate.getFullYear() === now.getFullYear() &&
          logoutDate.getMonth() === now.getMonth() &&
          logoutDate.getDate() === now.getDate()
        ) {
          return true;
        }
      }
    }
    return false;
  }

  async function oneTapLogin(credential) {
    reportOneTapEvent('one_tap_login_attempt');
    try {
      const response = await fetch(apiUrl + '/newOfficialWebsite/proxy/user/login/google/one-tap', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-Site-Code': window.site || 'US'
        },
        body: JSON.stringify({
          credential: credential,
          returnTo: window.location.href
        }),
      });
      const res = await response.json();

      if(res.code == 200 && res.data.multipassUrl){
        window.location.replace(res.data.multipassUrl);
      }else{
        throw new Error(res.message);
      }
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  function handleCredentialResponse(response) {
    if (!response || !response.credential) return;
    oneTapLogin(response.credential);
  }

  function initializeOneTap() {
    if (initialized || !window.google || !window.google.accounts || !window.google.accounts.id) {
      return;
    }
    if (isAccountLogoutFlow()) { //判断是否是当天退出登录页面，如果是则不弹出弹窗
      window.google.accounts.id.disableAutoSelect();
      return;
    }
    initialized = true;
    window.google.accounts.id.initialize({
      client_id: clientId,
      callback: handleCredentialResponse,
      auto_select: true,
      cancel_on_tap_outside: false,
      context: 'signin',
      itp_support: true,
      use_fedcm_for_button: true,
      button_auto_select: true,
    });
    window.google.accounts.id.prompt();
    reportOneTapEvent('one_tap_displayed');
  }

  function loadGoogleIdentityServices() {
    if(window.innerWidth < 768 && enabledMb === 'false') { // 小屏设备不弹出弹窗
      return;
    }
    if (window.google && window.google.accounts && window.google.accounts.id) {
      initializeOneTap();
      return;
    }
    if (document.querySelector('script[src="' + scriptSrc + '"]')) {
      window.addEventListener('load', initializeOneTap, { once: true });
      return;
    }

    var script = document.createElement('script');
    script.src = scriptSrc;
    script.async = true;
    script.defer = true;
    script.onload = initializeOneTap;
    document.head.appendChild(script);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadGoogleIdentityServices, { once: true });
  } else {
    loadGoogleIdentityServices();
  }
})();